/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import preview from 'ui/components/theme/preview.mixin';

const __vue_script__ = {
    name: 'OverallAvailabilityPreview',

    mixins: [preview],
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "request-preview",
      attrs: {
        viewBox: "0 0 900 550",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("defs", [
        _c(
          "pattern",
          {
            attrs: {
              id: "diagonalHatch",
              width: "6",
              height: "6",
              patternTransform: "rotate(45 0 0)",
              patternUnits: "userSpaceOnUse",
            },
          },
          [
            _c("line", {
              attrs: {
                x1: "0",
                y1: "0",
                x2: "0",
                y2: "6",
                stroke: "#E0E0E0",
                "stroke-width": "1",
              },
            }),
          ]
        ),
      ]),
      _c("g", { attrs: { "clip-path": "url(#clip_page_shape)" } }, [
        _c("rect", { attrs: { width: "900", height: "550", fill: "#E8EAEB" } }),
        _vm.backgroundImageUrl
          ? _c("image", {
              attrs: {
                href: _vm.backgroundImageUrl,
                width: "900",
                height: "550",
                preserveAspectRatio: "xMidYMid slice",
              },
            })
          : _vm._e(),
        _c(
          "g",
          {
            staticClass: "card-container",
            attrs: { transform: "translate(112.5, 85) scale(0.75)" },
          },
          [
            _c("g", { staticClass: "card" }, [
              _c("rect", {
                attrs: {
                  x: "50",
                  y: "30",
                  width: "800",
                  height: "580",
                  rx: "16",
                  fill: "#FFFFFF",
                },
              }),
              _c(
                "text",
                {
                  attrs: {
                    x: "90",
                    y: "85",
                    "font-family": "sans-serif",
                    "font-weight": "bold",
                    "font-size": "28",
                    fill: "#111111",
                  },
                },
                [_vm._v("Choose all available times")]
              ),
              _c("g", { staticClass: "top-info" }, [
                _c("circle", {
                  attrs: {
                    cx: "99",
                    cy: "113",
                    r: "3.5",
                    stroke: "#7A3B99",
                    "stroke-width": "1.5",
                    fill: "none",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M92 122c0-3.5 2.5-5 7-5s7 1.5 7 5",
                    stroke: "#7A3B99",
                    "stroke-width": "1.5",
                    fill: "none",
                    "stroke-linecap": "round",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "115",
                    y: "108",
                    width: "130",
                    height: "14",
                    rx: "7",
                    fill: "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "630",
                    y: "108",
                    width: "130",
                    height: "14",
                    rx: "7",
                    fill: "#E5E6E6",
                  },
                }),
              ]),
              _c("line", {
                attrs: {
                  x1: "90",
                  y1: "135",
                  x2: "760",
                  y2: "135",
                  stroke: "#F0F0F0",
                  "stroke-width": "1",
                },
              }),
              _c("g", { staticClass: "date-pickers" }, [
                _c("rect", {
                  attrs: {
                    x: "90",
                    y: "150",
                    width: "320",
                    height: "42",
                    rx: "8",
                    stroke: _vm.primaryColor || "#4A148C",
                    "stroke-width": "1",
                    fill: _vm.primaryColor || "#4A148C",
                    "fill-opacity": "0.1",
                  },
                }),
                _c("g", { staticClass: "calendar-icon-left" }, [
                  _c("rect", {
                    attrs: {
                      x: "105",
                      y: "162",
                      width: "20",
                      height: "18",
                      rx: "2",
                      stroke: "#333",
                      "stroke-width": "1.2",
                      fill: "none",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M105 168h20M110 160v4M120 160v4",
                      stroke: "#333",
                      "stroke-width": "1.2",
                      "stroke-linecap": "round",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M112 171l6 6m0-6l-6 6",
                      stroke: "#333",
                      "stroke-width": "1",
                      "stroke-linecap": "round",
                    },
                  }),
                ]),
                _c("rect", {
                  attrs: {
                    x: "430",
                    y: "150",
                    width: "330",
                    height: "42",
                    rx: "8",
                    stroke: "#E5E6E6",
                    fill: "none",
                    "stroke-width": "1",
                  },
                }),
                _c("g", { staticClass: "calendar-icon-right" }, [
                  _c("rect", {
                    attrs: {
                      x: "445",
                      y: "162",
                      width: "20",
                      height: "18",
                      rx: "2",
                      stroke: "#333",
                      "stroke-width": "1.2",
                      fill: "none",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M445 168h20M450 160v4M460 160v4",
                      stroke: "#333",
                      "stroke-width": "1.2",
                      "stroke-linecap": "round",
                    },
                  }),
                ]),
              ]),
              _c("g", { staticClass: "timeline-header" }, [
                _c("rect", {
                  attrs: {
                    x: "230",
                    y: "215",
                    width: "40",
                    height: "10",
                    rx: "5",
                    fill: "#F0F0F0",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "290",
                    y: "215",
                    width: "40",
                    height: "10",
                    rx: "5",
                    fill: "#F0F0F0",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "350",
                    y: "215",
                    width: "40",
                    height: "10",
                    rx: "5",
                    fill: "#F0F0F0",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "410",
                    y: "215",
                    width: "40",
                    height: "10",
                    rx: "5",
                    fill: "#F0F0F0",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "470",
                    y: "215",
                    width: "40",
                    height: "10",
                    rx: "5",
                    fill: "#F0F0F0",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "530",
                    y: "215",
                    width: "40",
                    height: "10",
                    rx: "5",
                    fill: "#F0F0F0",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "590",
                    y: "215",
                    width: "40",
                    height: "10",
                    rx: "5",
                    fill: "#F0F0F0",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "650",
                    y: "215",
                    width: "40",
                    height: "10",
                    rx: "5",
                    fill: "#F0F0F0",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "710",
                    y: "215",
                    width: "40",
                    height: "10",
                    rx: "5",
                    fill: "#F0F0F0",
                  },
                }),
              ]),
              _c("g", { staticClass: "grid-lines" }, [
                _c("line", {
                  attrs: {
                    x1: "90",
                    y1: "245",
                    x2: "760",
                    y2: "245",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "90",
                    y1: "305",
                    x2: "760",
                    y2: "305",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "90",
                    y1: "365",
                    x2: "760",
                    y2: "365",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "90",
                    y1: "425",
                    x2: "760",
                    y2: "425",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "90",
                    y1: "485",
                    x2: "760",
                    y2: "485",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "220",
                    y1: "245",
                    x2: "220",
                    y2: "485",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "280",
                    y1: "245",
                    x2: "280",
                    y2: "485",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "340",
                    y1: "245",
                    x2: "340",
                    y2: "485",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "400",
                    y1: "245",
                    x2: "400",
                    y2: "485",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "460",
                    y1: "245",
                    x2: "460",
                    y2: "485",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "520",
                    y1: "245",
                    x2: "520",
                    y2: "485",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "580",
                    y1: "245",
                    x2: "580",
                    y2: "485",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "640",
                    y1: "245",
                    x2: "640",
                    y2: "485",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "700",
                    y1: "245",
                    x2: "700",
                    y2: "485",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "760",
                    y1: "245",
                    x2: "760",
                    y2: "485",
                    stroke: "#F0F0F0",
                    "stroke-width": "1",
                  },
                }),
              ]),
              _c("g", { staticClass: "left-column" }, [
                _c("rect", {
                  attrs: {
                    x: "90",
                    y: "260",
                    width: "70",
                    height: "10",
                    rx: "5",
                    fill: "#E5E6E6",
                  },
                }),
                _c("circle", {
                  attrs: { cx: "95", cy: "285", r: "5", fill: "#E5E6E6" },
                }),
                _c("rect", {
                  attrs: {
                    x: "110",
                    y: "280",
                    width: "60",
                    height: "10",
                    rx: "5",
                    fill: "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "90",
                    y: "320",
                    width: "70",
                    height: "10",
                    rx: "5",
                    fill: "#E5E6E6",
                  },
                }),
                _c("circle", {
                  attrs: { cx: "95", cy: "345", r: "5", fill: "#E5E6E6" },
                }),
                _c("rect", {
                  attrs: {
                    x: "110",
                    y: "340",
                    width: "60",
                    height: "10",
                    rx: "5",
                    fill: "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "90",
                    y: "380",
                    width: "70",
                    height: "10",
                    rx: "5",
                    fill: "#E5E6E6",
                  },
                }),
                _c("circle", {
                  attrs: { cx: "95", cy: "405", r: "5", fill: "#E5E6E6" },
                }),
                _c("rect", {
                  attrs: {
                    x: "110",
                    y: "400",
                    width: "60",
                    height: "10",
                    rx: "5",
                    fill: "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "90",
                    y: "440",
                    width: "70",
                    height: "10",
                    rx: "5",
                    fill: "#E5E6E6",
                  },
                }),
                _c("circle", {
                  attrs: { cx: "95", cy: "465", r: "5", fill: "#E5E6E6" },
                }),
                _c("rect", {
                  attrs: {
                    x: "110",
                    y: "460",
                    width: "60",
                    height: "10",
                    rx: "5",
                    fill: "#E5E6E6",
                  },
                }),
              ]),
              _c("g", { staticClass: "grid-content" }, [
                _c("rect", {
                  attrs: {
                    x: "220",
                    y: "257",
                    width: "60",
                    height: "36",
                    rx: "6",
                    fill: "url(#diagonalHatch)",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "520",
                    y: "257",
                    width: "180",
                    height: "36",
                    rx: "6",
                    fill: _vm.primaryColor || "#A282C6",
                    "fill-opacity": "0.5",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "340",
                    y: "317",
                    width: "360",
                    height: "36",
                    rx: "6",
                    fill: _vm.primaryColor || "#A282C6",
                    "fill-opacity": "0.5",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "220",
                    y: "437",
                    width: "180",
                    height: "36",
                    rx: "6",
                    fill: _vm.primaryColor || "#A282C6",
                    "fill-opacity": "0.5",
                  },
                }),
              ]),
              _c("line", {
                attrs: {
                  x1: "90",
                  y1: "520",
                  x2: "760",
                  y2: "520",
                  stroke: "#F0F0F0",
                  "stroke-width": "1",
                },
              }),
              _c("g", { staticClass: "footer" }, [
                _c("rect", {
                  attrs: {
                    x: "90",
                    y: "555",
                    width: "125",
                    height: "14",
                    rx: "7",
                    fill: "#E5E6E6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "225",
                    y: "555",
                    width: "12",
                    height: "14",
                    rx: "5",
                    fill: "#D1D1D1",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "445",
                    y: "540",
                    width: "175",
                    height: "44",
                    rx: "8",
                    fill: "#F5F5F5",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "485",
                    y: "557",
                    width: "95",
                    height: "10",
                    rx: "5",
                    fill: "#555555",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "640",
                    y: "540",
                    width: "120",
                    height: "44",
                    rx: "8",
                    fill: _vm.primaryColor || "#4A148C",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "665",
                    y: "557",
                    width: "70",
                    height: "10",
                    rx: "5",
                    fill: "#FFFFFF",
                  },
                }),
              ]),
            ]),
          ]
        ),
        _c("rect", {
          staticClass: "page_borders",
          attrs: {
            x: "0.5",
            y: "0.5",
            width: "899",
            height: "649",
            rx: "7.5",
            stroke: "#E5E6E6",
          },
        }),
      ]),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/meeting-requests/theme/OverallAvailabilityPreview.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__